var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_49)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H5.625C2.5184 0 0 2.5184 0 5.625V18.375C0 21.4816 2.5184 24 5.625 24H18.375C21.4816 24 24 21.4816 24 18.375V5.625C24 2.5184 21.4816 0 18.375 0Z",
    fill: "#F4F2ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_289_49",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 14,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71875 2.625H18.2213V21.375H5.71875V2.625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_289_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84503 21.375C10.57 21.375 11.97 19.9751 11.97 18.2501V15.125H8.84503C7.12003 15.125 5.71997 16.5251 5.71997 18.2501C5.71997 19.9751 7.12003 21.375 8.84503 21.375Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71997 12C5.71997 10.275 7.12003 8.875 8.84503 8.875H11.97V15.1249H8.84503C7.12003 15.1249 5.71997 13.725 5.71997 12Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71997 5.74997C5.71997 4.02497 7.12003 2.625 8.84503 2.625H11.97V8.87503H8.84503C7.12003 8.87503 5.71997 7.47497 5.71997 5.74997Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.97 2.625H15.095C16.82 2.625 18.22 4.02497 18.22 5.74997C18.22 7.47497 16.82 8.87503 15.095 8.87503H11.97V2.625Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.22 12C18.22 13.725 16.82 15.1249 15.095 15.1249C13.37 15.1249 11.97 13.725 11.97 12C11.97 10.275 13.37 8.875 15.095 8.875C16.82 8.875 18.22 10.275 18.22 12Z",
    fill: "#1ABCFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.75df4b1ee85ec84b83ecb14c2aec8542.svg";
export { ForwardRef as ReactComponent };